import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';

// Filter out browser extension console noise in development
import 'src/utils/consoleFilter';

// Prevent browser extension interference
import 'src/styles/extensionFix.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>
);

// Only enable service worker in production and when not on localhost
const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(
    window.location.hostname
  );

if (process.env.NODE_ENV === 'production' && !isLocalhost) {
  serviceWorker.register({
    onSuccess: () => {
      console.log('Service worker registered successfully');
    },
    onUpdate: () => {
      console.log('New app version available');
    }
  });
} else {
  // Ensure any previously registered SW is removed in dev/localhost
  serviceWorker.unregister();
}
